import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import PacmanWrapper from "../../components/dashboard/PacmanWrapper";
import core from "../../vendors/core-api";
import NotFound from "./NotFoundPageEvent";

const BookingLink = () => {
  const [redirect, setRedirect] = useState(false);
  const [storeData, setStoreData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { store_url: storeUrl } = useParams();

  useEffect(() => {
    const fetchEventData = async () => {
      const api = core("pu").get();

      try {
        setLoading(true);
        let hostname = window.location.hostname;

        if (hostname.includes("localhost")) {
          hostname = import.meta.env.VITE_APP_HOSTNAME;
        }

        const [brand = ""] = hostname.replace("www.", "").split(".");

        const response = await api.get(`/branded-website/brands/${brand}`);

        if (response.status >= 400) {
          throw new Error("Brand not found");
        }

        const stores = response.data.stores;

        let targetStore;

        if (Array.isArray(stores)) {
          targetStore = stores.find(({ store_url }) => store_url === storeUrl);
        }

        if (!targetStore) {
          throw new Error("Store not found in brand");
        }

        setStoreData(targetStore);
        setRedirect(
          `${import.meta.env.VITE_APP_BOOKING_URL}?id=${targetStore._id}`,
        );
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    if (storeUrl) {
      fetchEventData();
    }
  }, [storeUrl]);

  if (loading) {
    return <PacmanWrapper />;
  }

  if (error) {
    return <NotFound />;
  }

  if (redirect && storeData) {
    window.location.assign(redirect);
    return null;
  }

  return <PacmanWrapper />;
};

export default BookingLink;
